/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
import React from "react";
export const SvgToolbarSave: React.FC<React.SVGAttributes<SVGElement>> = (
    props
) => (
    <svg viewBox="0 0 20 20" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill="currentColor"
                d="M13.172 2c.53 0 1.039.21 1.414.586l2.828 2.828A2 2 0 0118 6.828V17a1 1 0 01-1 1H3a1 1 0 01-1-1V3a1 1 0 011-1h10.172zM6 3.5H3.5v13H5V11a1 1 0 011-1h8a1 1 0 011 1v5.5h1.567V6.732L14 4.148V7a1 1 0 01-.883.993L13 8H7a1 1 0 01-1-1V3.5zm7.5 8h-7v5h7v-5zm-1-8h-5v3h5v-3z"
            />
            <path d="M0 0h20v20H0z" />
        </g>
    </svg>
);
